module.exports = __webpack_public_path__ + "img/MA3D-Mini.4faad6cc.png";